import { createBrowserRouter, Navigate } from "react-router-dom";

import EventBookingDetails from "./modals/booking/EventBookingDetails";
import AddNewEvent from "./modals/businessProfile/action/AddNewEvent";
import BusinessProfileUpComplete from "./modals/businessProfile/BusinessProfileComplete";
import BusinessProfileUpSubscription from "./modals/businessProfile/BusinessProfileUpSubscription";
import BusinessProfileUpSubscriptionSuccess from "./modals/businessProfile/BusinessProfileUpSubscriptionSuccess";
import BusinessProfileUpSubscriptionUpgrade from "./modals/businessProfile/BusinessProfileUpSubscriptionUpgrade";
import EventDetails from "./modals/businessProfile/EventDetails";
import EventList from "./modals/businessProfile/EventList";
import ScheduleEventList from "./modals/businessProfile/ScheduleEventList";
import BusinessProfileEventSession from "./modals/businessProfile/view/BusinessProfileEventSession";
import Home from "./modals/dashboard/Home";
import ForgotPassword from "./modals/forgotPassword";
import ResetPassword from "./modals/forgotPassword/ResetPassword";
import VerifyForgotPassword from "./modals/forgotPassword/Verify";
import LocationList from "./modals/myLocation/LocationList";
import BusinessPaymentProfile from "./modals/paymentProfile/BusinessPaymentProfile";
import SellersList from "./modals/sellers/SellersList";
import EditBusinessProfile from "./modals/settings/businessProfile/EditBusinessProfile";
import ManageOnlineBooking from "./modals/settings/manageOnlineBooking";
import MyAccount from "./modals/settings/myAccount/MyAccount";
import SignIn from "./modals/signin";
import SignUp from "./modals/signup";
import OnBording from "./modals/signup/onbording";
import StripPaymentOnBording from "./modals/signup/onbording/stripPaymentOnBording";
import VerifyNumber from "./modals/verifyCredentials/VerifyNumber";
import GuestsList from "./modals/guests/GuestsList";
import SellersEventList from "./modals/sellers/events/SellersEventList";
import SellersEventDetail from "./modals/sellers/events/SellersEventDetail";
import MyPromotions from "./modals/promotions/MyPromotions";
import ProductsPage from "./modals/products/ProductsPage";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <SignIn />,
  },
  {
    path: "/signup",
    element: <SignUp />,
  },
  {
    path: "/signup/verifynumber",
    element: <VerifyNumber />,
  },
  {
    path: "/businessprofilesetup/verifynumber",
    element: <VerifyNumber />,
  },
  {
    path: "/businessprofilesetup/done",
    element: <BusinessProfileUpComplete />,
  },
  {
    path: "/businessprofilesetup/subscription",
    element: <BusinessProfileUpSubscription />,
  },
  {
    path: "/my-subscription",
    element: <BusinessProfileUpSubscriptionUpgrade />,
  },
  {
    path: "/businessprofilesetup/subscription/upgrade",
    element: <BusinessProfileUpSubscriptionUpgrade />,
  },
  {
    path: "/businessprofilesetup/subscription/success",
    element: <BusinessProfileUpSubscriptionSuccess landFor="success" />,
  },
  {
    path: "/businessprofilesetup/subscription/cancel",
    element: <BusinessProfileUpSubscriptionSuccess landFor="cancel" />,
  },
  {
    path: "/myevents/new",
    element: (
      <AddNewEvent

        profileFor="event"
        title="Event"
      />
    ),
  },
  {
    path: "/myevents",
    element: (
      <EventList profileFor="event" title="My Events" />
    ),
  },
  {
    path: "/myschedule",
    element: (
      <ScheduleEventList

        profileFor="event"
        // title="Schedule"
        title="My Events"
      />
    ),
  },
  {
    path: "/myschedule/detail",
    element: <BusinessProfileEventSession />,
  },
  {
    path: "/myevents/detail",
    element: <EventDetails profileFor="event" />,
  },
  {
    path: "/businessprofile/update",
    element: <EditBusinessProfile />,
  },
  {
    path: "/home/dashboard",
    element: <Home />,
  },
  {
    path: "/mylocation",
    element: <LocationList
      profileFor="location"
      title="My Location" />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/forgot-password/verify",
    element: <VerifyForgotPassword />,
  },
  {
    path: "/forgot-password/reset",
    element: <ResetPassword />,
  },
  {
    path: "/payment/profile",
    element: <BusinessPaymentProfile screenView="full" />,
  },
  {
    path: "/booking/view",
    element: <EventBookingDetails />,
  },
  {
    path: "/manage-online-booking",
    element: (
      <ManageOnlineBooking

        title="Manage Online Booking"
      />
    ),
  },
  {
    path: "/my-account",
    element: <MyAccount selectedTab="account" title="Account Settings" />,
  },
  {
    path: "/my-account/billing",
    element: <MyAccount selectedTab="billing" title="Billing" />,
  },
  {
    path: "/my-account/online-payment",
    element: <MyAccount selectedTab="online-payment" title="Online Payment" />,
  },
  {
    path: "/on-bording",
    element: <OnBording selectedTab="phone-verify" title="Phone Verify" />,
  },
  {
    path: "/on-bording/payment-setup",
    element: <StripPaymentOnBording selectedTab="phone-verify" title="Payment Setup" />,
  },
  {
    path: "/mysellers",
    element: <SellersList
      title="My Sellers" />,
  },
  {
    path: "/myguests",
    element: <GuestsList
      title="My Guests" />,
  },
  {
    // Catalogue of non-ticket items plus the on-site sales they generate, as two tabs.
    path: "/products",
    element: <ProductsPage />,
  },
  {
    // Kept so existing links and bookmarks still land somewhere sensible.
    path: "/onsite-sales",
    element: <Navigate to="/products?tab=sales" replace />,
  },
  {
    path: "/seller/:sellerUserId/events",
    element: <SellersEventList
      title="Sellers Events" />,
  },
  {
    path: "/seller/:sellerUserId/eventDetail",
    element: <SellersEventDetail />,
  },
  {
    path: "/mypromotions",
    element: <MyPromotions />,
  },
  {
    path: "*",
    element: <Navigate replace to="/home/dashboard" />,
  },
]);
